module.exports = __webpack_public_path__ + "img/openBox-blue.d99ab818.png";